export default {
    name: "Water Used & Saved Data",
    children: [
      {
        name: "2020",
        children: [
          {
            name: "Banaskantha",
            children: [
              {
                name: "Water used 20 lt.",
                size: 8
              },
              {
                name: "Water Saved 7 lt",
                size: 8
              }
            ]
          },
          {
            name: "Sabarkantha",
            children: [
              {
                name: "Water used 20 lt.",
                size: 8
              },
              {
                name: "Water Saved 7 lt",
                size: 8
              }
            ]
          },
          {
            name: "Mehsana",
            children: [
              {
                name: "Water used 20 lt.",
                size: 8
              },
              {
                name: "Water Saved 7 lt",
                size: 8
              }
            ]
          },
          {
            name: "Patan",
            children: [
              {
                name: "Water used 20 lt.",
                size: 8
              },
              {
                name: "Water Saved 7 lt",
                size: 8
              }
            ]
          }
        ]
      },
      {
        name: "2021",
        children: [
          {
            name: "Banaskantha",
            children: [
              {
                name: "Water used 20 lt.",
                size: 8
              },
              {
                name: "Water Saved 7 lt",
                size: 8
              }
            ]
          },
          {
            name: "Sabarkantha",
            children: [
              {
                name: "Water used 20 lt.",
                size: 8
              },
              {
                name: "Water Saved 7 lt",
                size: 8
              }
            ]
          },
          {
            name: "Mehsana",
            children: [
              {
                name: "Water used 20 lt.",
                size: 8
              },
              {
                name: "Water Saved 7 lt",
                size: 8
              }
            ]
          },
          {
            name: "Patan",
            children: [
              {
                name: "Water used 20 lt.",
                size: 8
              },
              {
                name: "Water Saved 7 lt",
                size: 8
              }
            ]
          }
        ]
      },
      {
        name: "2019",
        children: [
          {
            name: "Banaskantha",
            children: [
              {
                name: "Water used 20 lt.",
                size: 8
              },
              {
                name: "Water Saved 7 lt",
                size: 8
              }
            ]
          },
          {
            name: "Sabarkantha",
            children: [
              {
                name: "Water used 20 lt.",
                size: 8
              },
              {
                name: "Water Saved 7 lt",
                size: 8
              }
            ]
          },
          {
            name: "Mehsana",
            children: [
              {
                name: "Water used 20 lt.",
                size: 8
              },
              {
                name: "Water Saved 7 lt",
                size: 8
              }
            ]
          },
          {
            name: "Patan",
            children: [
              {
                name: "Water used 20 lt.",
                size: 8
              },
              {
                name: "Water Saved 7 lt",
                size: 8
              }
            ]
          }
        ]
      }
    ]
  };
  